module.exports = __webpack_public_path__ + "img/HA1502-76.0cc205ed.jpg";